var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInternationalMinutes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M25.888 34.784v-2.16l1.696-1.68v-1.68l.832-.848 1.696-1.68v-.848l-2.528-.832-1.696-3.376v-.832h-2.512l-.848.832h-.848l-.832-.832L20 20h-2.528l-1.68.848-1.68 1.68v2.528l.832 2.528 1.68.832h2.528l1.696.848v.848l.832 1.68v.832l.848 1.696 2.048 1.024 1.312-.56z",
    fill: "url(#cbsx07xo7a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M36 19.152h-.016l-.832.848-1.68-1.696-.848-.832h-.832v.832l-.848.848V20l.848.832v.848l-.848 1.68h-1.68l-.848-1.68-.832-4.208h-.848l-.848.832h-.832l-.848-1.68H21.68l-.832.848h-3.376v-1.696l.848-.832h.832l.848-.848h.848L20 12.416l.848-2.528 2.256-.752 1.152-2.544-.048-.08.848-1.68a16.004 16.004 0 0 1 10.928 14.304H36v.016z",
    fill: "url(#o1zmqjh3jb)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M14.944 4.848h.848l.848.848v.848l-1.68.848h-1.68l-.848.848-.848.848v.848l-.848.848-1.68.848-1.68.848H5.92s3.136-6.112 9.024-7.632z",
    fill: "url(#13p1tk092c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M9.056 31.665v-1.568l.848-1.68v-.848l-1.68-.848-1.68-2.528v-2.528l-.848-.848-1.68-2.528s.096 9.024 5.056 13.36l-.016.016z",
    fill: "url(#7hbhsiai8d)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m36 19.152-.848.848-2.528-2.528h-.832v.848l-.848.832V20l.848.848v.832l-.848 1.696h-1.68l-.848-1.696-.832-4.208h-.848l-.848.848h-.832l-.848-1.696H21.68l-.832.848h-3.376v-1.68l.848-.848h.832l.848-.832h.848m0 0h.832l1.696-1.696v-.832m-2.528 2.528L20 12.416l.848-2.528 2.528-.832h1.68v-.848l-.848-1.68.848-1.68m-.48 30.496-2.048-1.024-.848-1.696v-.832l-.832-1.68v-.848l-1.696-.848h-2.528l-1.68-.832-.832-2.528v-2.528l1.68-1.68 1.68-.848H20l1.68 1.68h.848l.848-.832h2.512v.832l1.696 3.376 2.528.832v.848l-1.696 1.68-.832.848v1.68l-1.696 1.68v2.16m4.224-2.384v-2.288M16.624 12.416l.848-.832.848-2.528m-3.376-4.208h.848l.832.832v.848l-1.68.848h-1.68l-.848.832-.832.848v.832l-.848.848-1.68.848-1.68.832H5.904M4 18.32l1.68 2.528.848.832v2.528l1.68 2.528 1.68.848v.832l-.832 1.696v1.552M36 20c0 8.837-7.163 16-16 16S4 28.837 4 20 11.163 4 20 4s16 7.163 16 16z",
    stroke: "url(#ttwljduhae)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cbsx07xo7a",
    x1: 14.112,
    y1: 28.923,
    x2: 29.857,
    y2: 23.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o1zmqjh3jb",
    x1: 17.472,
    y1: 15.606,
    x2: 35.857,
    y2: 9.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "13p1tk092c",
    x1: 5.92,
    y1: 9.286,
    x2: 15.646,
    y2: 4.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "7hbhsiai8d",
    x1: 4.016,
    y1: 26.067,
    x2: 10.35,
    y2: 25.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ttwljduhae",
    x1: 4,
    y1: 22.608,
    x2: 35.754,
    y2: 12.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternationalMinutes);
export default __webpack_public_path__ + "static/media/internationalMinutes.e5bc87fe6377557dd9f8c0a389676420.svg";
export { ForwardRef as ReactComponent };